import { useLifecyclePersistence, useSyncLifecycleToExistingAtom } from '../../utilities'
import { ConformedCampaignReview } from '../../views'
import {
	campaignReviewAtom,
	campaignReviewSavingAtom,
	campaignReviewStatusAtom,
	useCampaignReviewListener,
} from '../state/review-atoms'

export type UseReviewEditorArguments = {
	review: ConformedCampaignReview | undefined
	isPending: boolean
	isSaving: boolean
	isGenerating: boolean
	onReviewChange: (review: ConformedCampaignReview) => void
	reviewVersion?: number | string | Date | null
}

export function useReviewEditor({
	review,
	isPending,
	isSaving,
	isGenerating,
	onReviewChange,
	reviewVersion,
}: UseReviewEditorArguments) {
	const reviewLifecycle = useLifecyclePersistence<ConformedCampaignReview>({
		data: review ?? undefined,
		isIdle: (d) => d == undefined,
		isPending: () => isPending,
		isGenerating: () => isGenerating,
		save: async (reviewData) => {
			await onReviewChange(reviewData)
		},
		debounceMs: 500,
		getVersion: () => reviewVersion ?? null,
		debug: false,
		name: 'useReviewEditor',
	})

	useSyncLifecycleToExistingAtom(reviewLifecycle, {
		dataAtom: campaignReviewAtom,
		useDataListener: useCampaignReviewListener,
		lifecycleAtom: campaignReviewStatusAtom,
		persistenceAtom: campaignReviewSavingAtom,
	})

	return {}
}
